interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
  description?: string;
  id?: string;
}

export default function Switch({
  checked,
  onChange,
  disabled,
  label,
  description,
  id,
}: SwitchProps) {
  const control = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-labelledby={id}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={[
        "relative inline-flex items-center shrink-0 h-5 w-9 rounded-full",
        "transition-colors duration-200",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        checked ? "bg-brand-500" : "bg-ink-200",
      ].join(" ")}
    >
      <span
        className={[
          "inline-block h-3.5 w-3.5 rounded-full bg-white shadow",
          "transition-transform duration-200",
          checked ? "translate-x-[18px]" : "translate-x-[2px]",
        ].join(" ")}
      />
    </button>
  );

  if (!label) return control;

  return (
    <label className="flex items-start gap-3 cursor-pointer select-none">
      {control}
      <span className="flex-1">
        <span id={id} className="block text-sm font-medium text-ink-800">
          {label}
        </span>
        {description && (
          <span className="block text-xs text-ink-500 mt-0.5">
            {description}
          </span>
        )}
      </span>
    </label>
  );
}
